
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Calculez dans quelles situations le risque est le plus élevé`}</h1>
    <h2>{`Avec le variant Delta, les aérosols représentent en grand danger. Calculez au cas par cas votre risque d'infection avec notre outil.`}</h2>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;